import { useCallback } from "react";

const useAssetPreview = ({ mediaType }) => {
    const getElementThumbnailUrl = useCallback((previews) => {
        const largestElementPreview = previews?.[previews?.length - 1]?.accessUrl;

        return largestElementPreview;
    }, []);

    const getPreviewStatus = useCallback(
        (previews) => {
            const defaultPreviewValue = mediaType === "IMAGE" ? "COMPLETE" : ""; //Note: 이미지 에셋의 경우 원본 이미지 표시, 그 외의 경우 기본 미디어타입 아이콘 표시

            return previews?.[previews?.length - 1]?.status ?? defaultPreviewValue;
        },
        [mediaType],
    );

    return {
        getElementThumbnailUrl,
        getPreviewStatus,
    };
};

export default useAssetPreview;
